import {DigitalDocumentFieldSetUp, DigitalTaskCondition} from "types/tasks"

export const useDigitalSetup = () => {
    const conditionOptions = [{id: DigitalTaskCondition.FILLED_OUT, name: "Is Filled Out"}]
    const multiFieldValuesOptions = [
        {id: DigitalTaskCondition.FILLED_OUT, name: "Is Filled Out"},
        {id: DigitalTaskCondition.EQUALS_TO, name: "Equals To"}
    ]
    const labelByType = {
        [DigitalDocumentFieldSetUp.CHECKBOX]: "Checkbox",
        [DigitalDocumentFieldSetUp.FILE]: "File",
        [DigitalDocumentFieldSetUp.GRADE]: "Grade",
        [DigitalDocumentFieldSetUp.INITIAL]: "Initial",
        [DigitalDocumentFieldSetUp.SELECT]: "Select",
        [DigitalDocumentFieldSetUp.SIGNATURE]: "Signature",
        [DigitalDocumentFieldSetUp.TEXT]: "Text"
    }
    const fieldHasMultipleOptions = [
        DigitalDocumentFieldSetUp.CHECKBOX,
        DigitalDocumentFieldSetUp.INITIAL,
        DigitalDocumentFieldSetUp.SELECT
    ]

    const getScaleInfo = ({pageRef, taskData}) => {
        const pageHeight = pageRef?.current?.offsetHeight
        const pageWidth = pageRef?.current?.offsetWidth
        const {width = pageWidth, height = pageHeight} = taskData.digitalDocument.pages?.[0] || {}
        const scaleHeight = height / pageHeight
        const scaleWidth = width / pageWidth
        return {scaleHeight, scaleWidth, pageHeight, pageWidth}
    }

    const scalePlaceInformation = (placeInformation, {scaleHeight, scaleWidth}, isSubmit = true) => {
        const {top, left, width, height} = placeInformation
        if (isSubmit) {
            return {
                width: width * scaleWidth,
                height: height * scaleHeight,
                top: top * scaleHeight,
                left: left * scaleWidth
            }
        }
        return {
            width: width / scaleWidth,
            height: height / scaleHeight,
            top: top / scaleHeight,
            left: left / scaleWidth
        }
    }

    const getIconByType = (type) => {
        switch (type) {
            case DigitalDocumentFieldSetUp.SIGNATURE:
                return "SIGN_HAND_DRAWN"
            case DigitalDocumentFieldSetUp.INITIAL:
                return "INITIALS"
            case DigitalDocumentFieldSetUp.TEXT:
                return "TEXT"
            case DigitalDocumentFieldSetUp.CHECKBOX:
                return "CHECKBOX_CHECKED"
            case DigitalDocumentFieldSetUp.SELECT:
                return "ARROW_DOWN"
            case DigitalDocumentFieldSetUp.GRADE:
                return "GRADE"
            case DigitalDocumentFieldSetUp.FILE:
                return "FILE_UP"
            case DigitalDocumentFieldSetUp.DATE_FIELD:
                return "CALENDAR_FILL_INPUT"
            default:
                return "SIGN_HAND_DRAWN"
        }
    }

    return {
        conditionOptions,
        multiFieldValuesOptions,
        labelByType,
        fieldHasMultipleOptions,
        getScaleInfo,
        scalePlaceInformation,
        getIconByType
    }
}
